<template lang="pug">
.shareable-stamp
  .flex
    .caption(v-if="showCaption" v-text="caption")

    a.facebook(
      v-if="showFacebook"
      href="#"
      @click.prevent="shareToFacebook"
      v-tooltip="'Share to Facebook'")
      i.pf-icon.bx.bxl-facebook.icon

    a.twitter(
      v-if="showTwitter"
      :href="twitter"
      target="_blank"
      v-tooltip="'Share to Twitter'")
      i.pf-icon.bx.bxl-twitter.icon

    el-popover(
      @show="copy"
      @after-enter="copy"
      trigger="click"
      popper-class="popper-shareable-link")
      .form
        .header
          i.pf-icon.bx.bx-clipboard.mr
          span Link copied!
        input(
          @click.prevent="copy"
          type="text"
          :value="url"
          ref="url"
          readonly)
      a.copy(
        slot="reference"
        href="#"
        v-tooltip="'Click to copy shareable link'"
        @click.prevent)
        i.pf-icon.bx.bx-clipboard.mr.icon(size="18")
</template>

<script>
export default {
  props: {
    caption: {
      type: String,
      default: 'Share'
    },
    showCaption: {
      type: Boolean,
      default: false
    },
    showFacebook: {
      type: Boolean,
      default: false
    },
    showTwitter: {
      type: Boolean,
      default: false
    }
  },

   data () {
    return {
      url: null
    }
  },

  computed: {
    twitter () {
      return `http://twitter.com/share?url=${encodeURIComponent(this.url)}`
    }
  },

  watch: {
    '$route.query': {
      immediate: true,
      handler () {
        this.getUrl()
      }
    }
  },

  methods: {
    getUrl () {
      if (!process.client) return null
      this.url = window.location.href
    },

    copy () {
      this.$nextTick(() => {
        const input = this.$refs.url
        if (!input) return
        input.focus()
        input.select()
        input.setSelectionRange(0, input.value.length)
        document.execCommand('copy')
      })
    },

    shareToFacebook () {
      const url = this.url
      window.open(`https://www.facebook.com/sharer/sharer.php?u=${url}`, 'sharer', 'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=300,width=600')
    }
  }
}
</script>

<style lang="scss">
.popper-shareable-link {
  font-size: 12px;
  padding: 0;
  min-width: 300px;
  .header {
    padding: 0.5em;
    color: $--color-text-secondary;
    .icon {
      color: $--color-primary;
    }
  }
  input {
    font-size: 12px;
    font-family: $--font-family-monospace;
    width: 100%;
    appearance: none;
    border: none;
    display: block;
    outline: none;
    padding: .5em;
    background: lighten($--color-border-light, 2);
  }
}
</style>

<style lang="scss" scoped>
.shareable-stamp {
  color: $--color-text-secondary;
  .flex {
    * {
      display: block;
      &:not(:last-child) {
        margin-right: 15px;
      }
    }
  }
}
</style>
